import { ISaleSet } from "../../../model/respone/sale-set/ISaleSet";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eSaleSetActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ISaleSet[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ISaleSet,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ISaleSet,
    SAVE_SUCCESS: {} as ISaleSet,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    LOAD_BY_HOCSINH_START: 0,
    LOAD_BY_HOCSINH_SUCCESS: {} as ISaleSet[],
    LOAD_BY_HOCSINH_ERROR: ""
}

export const eSaleSetActionTypeIds = generateActionTypeIds(eSaleSetActionTypeDefine, "SALE_SET");

export type ISaleSetActions = IGenericActionType<typeof eSaleSetActionTypeDefine, "SALE_SET">;
